import { View, Accordion, Disclosure, DisclosureTitle, DisclosurePanel, Flex, RadioGroup, Radio, DateField, DatePicker, Heading, Divider, ActionButton } from '@adobe/react-spectrum';
import React, { useEffect, useRef, useState } from 'react';
import { ContactFormData } from '../AddNewPerson';
import { parseDate } from '@internationalized/date';
import { Check, ExclamationTriangle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

interface IMailSubscriptionSection{
  data: ContactFormData['massMailSubscription'];
  onChange: (data: ContactFormData['massMailSubscription']) => void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}

export const MailSubscriptionSection: React.FC<IMailSubscriptionSection> = ({ data, onChange,expandedSectionKey,setExpandedSectionKey,validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
  
  const [selectedType,setSelectedType] = useState<any>("")
  const [isSectionRequired,setIsSectionRequired] = useState(false);
  const { t } = useTranslation('contacts');
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
        // useEffect(() => {
        //     if(fieldConfig?.industry?.required
        //     ){
        //       setValidationStatus((prev:any) => ({ ...prev, ['industriesSection']: false }));
        //       setIsSectionRequired(true)
        //     } 
        //   }, [fieldConfig]);
        const radioRef = useRef<any>(null);
              useEffect(() => {
              if (expandedSectionKey?.has?.("mailSubscriptionSection")) {
                setTimeout(() => {
                  radioRef.current?.focus();
                }, 200); 
              }
            }, [expandedSectionKey]);
  const handleSectionExpandedChange = () => {
    setExpandedSectionKey((prevKey:any) => prevKey.has("mailSubscriptionSection") ? new Set() : new Set(["mailSubscriptionSection"]));
  };
  
  const handleConfirm = ()=>{
    setExpandedSectionKey(new Set(['groupsSection']))
  }
  return (
      <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id="mailSubscriptionSection"> 
        <DisclosureTitle>
        <Flex justifyContent="space-between" alignItems="center" width="100%">
          <View><span>{_tt(`mass_mail_subscription`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')}`}</span></View>
          {validationStatus.mailSubscriptionSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
        </Flex>
          
        </DisclosureTitle>
        <DisclosurePanel>
        <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
        <Flex direction="column" gap="size-100" width='100%'>
              <RadioGroup
                aria-label='Type'
                value={data.type}
                onChange={(type) => {
                  onChange({ ...data, type: type as 'Allowed' | 'Forbidden' | 'Unknown' })
                  setSelectedType(type as 'Allowed' | 'Forbidden' | 'Unknown')
                }
              }
              >
                <Flex gap='size-100' direction='row'>
                  <Radio ref={radioRef} aria-label='Allowed' value="Allowed">{_tt('allowed')}</Radio>
                  <Radio aria-label='Forbidden' value="Forbidden">{_tt('forbidden')}</Radio>
                  <Radio aria-label='Unknown' value="Unknown">{_tt('unknown')}</Radio>
                </Flex>
              </RadioGroup>
              <Flex gap="size-100" direction={{L:'row',base:'column'}} width='100%'>
                  <DatePicker aria-label='From' isDisabled = {selectedType === "Forbidden"}
                      value={!data.enabledFrom || selectedType === "Forbidden"
                      ? null : parseDate(data.enabledFrom)}
                      onChange={(value)=>{ 
                      if(!value) return;
                      const jsDate = new Date(value.year, value.month - 1, value.day);
                      const newData = {...data,enabledFrom:jsDate.toISOString().split("T")[0]};
                      onChange(newData);
                    }
                  } label={_tt("enabled_from")} width="50%" />
                  <DatePicker aria-label='To' isDisabled = {selectedType === "Forbidden"}
                      value={!data.enabledTo || selectedType === "Forbidden" ? null : parseDate(data.enabledTo)}
                      onChange={(value)=>{ 
                      if(!value) return;
                      const jsDate = new Date(value.year, value.month - 1, value.day);
                      const newData = {...data,enabledTo:jsDate.toISOString().split("T")[0]};
                      onChange(newData);
                    }
                  } label={_tt("enabled_to")} width="50%" />
                  <Flex justifyContent={'end'} marginTop={10} gap={'size-50'}>
                    <View marginTop={12}>
                      <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton>
                    </View>
                  </Flex>
              </Flex>
            </Flex>
            <Divider size='M' UNSAFE_style={{marginTop:10}}/>
        </DisclosurePanel>
        </Disclosure>
        </Accordion>
  );
}
  
